import { RedirectToAuthProps, redirectToAuth } from 'authorization-module'
import config from 'const/config'
import getApigeeClientId from 'helpers/getApigeeClientId'
import routes from 'const/routes'

const redirectToUniversalIDP = (client: string, prompt: string) => {
  const apigeeClientId = getApigeeClientId(client)
  const redirectUri = `${window.location.origin}${config.BASENAME}${routes.CALLBACK}`

  const authParams: RedirectToAuthProps = {
    baseURL: config.AUTH_DOMAIN,
    clientId: apigeeClientId,
    redirectURI: redirectUri
  }

  if (prompt && prompt !== 'reauth') {
    authParams.prompt = prompt
  }

  redirectToAuth(authParams)
}

export default redirectToUniversalIDP
